<div
  class="flex-1"
  [ngClass]="{
    'py-1': item.config.size === '1',
    'py-2': item.config.size === '2',
    'py-3': item.config.size === '3',
    'py-4': item.config.size === '4',
    'py-5': item.config.size === '5'
  }"
>
  @if (item.config.separator) {
    <div
      class="h-px -mx-2 border-b border-slate-300 {{
        item.config.dashed ? 'border-dashed' : ''
      }}"
    ></div>
  }
</div>
